import {
    defaultMarketResearchState,
    MarketResearchSearchCriteria,
    MarketResearchState,
    RelodeApiError,
} from "@relode/core";
import { JobManagerContact } from "core/src/domain";

export type ClientMarketResearchState = {
    searchMode: "configure" | "search";

    searchCriteria: MarketResearchSearchCriteria;

    searchResults: MarketResearchState;

    jobManager: {
        isBusy: boolean;
        error?: RelodeApiError;
        data?: JobManagerContact;
    };
};

export const defaultClientMarketResearchState: ClientMarketResearchState = {
    searchMode: "configure",

    searchCriteria: undefined,

    searchResults: defaultMarketResearchState,

    jobManager: {
        isBusy: false,
        error: undefined,
        data: undefined,
    },
};
